export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Spreadsheet System Comparison
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            See how the top three spreadsheet shopping platforms compare across key metrics
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl bg-background-50 border border-background-200/70">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="px-6 py-4 text-sm font-semibold text-foreground-900">System</th>
                <th className="px-6 py-4 text-sm font-semibold text-foreground-900">Update Speed</th>
                <th className="px-6 py-4 text-sm font-semibold text-foreground-900">Ease of Use</th>
                <th className="px-6 py-4 text-sm font-semibold text-foreground-900">Data Structure</th>
                <th className="px-6 py-4 text-sm font-semibold text-foreground-900">Best For</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/70 hover:bg-background-100/50 transition-colors">
                <td className="px-6 py-4">
                  <span className="text-sm font-semibold text-primary-600">GTBuy Spreadsheet</span>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-700">
                    <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                    High
                  </span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground-700">Medium</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground-700">Structured</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground-600">General Users</span>
                </td>
              </tr>
              <tr className="border-b border-background-200/70 hover:bg-background-100/50 transition-colors">
                <td className="px-6 py-4">
                  <span className="text-sm font-semibold text-foreground-800">Kakobuy Spreadsheet</span>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-700">
                    <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                    Medium
                  </span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground-700">High</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground-700">Semi-structured</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground-600">Beginners</span>
                </td>
              </tr>
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-6 py-4">
                  <span className="text-sm font-semibold text-foreground-800">Superbuy Spreadsheet</span>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-700">
                    <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                    High
                  </span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground-700">High</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground-700">Advanced</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-foreground-600">Power Users</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-6 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            Compare All Systems on KASpreadsheet
            <i className="ri-arrow-right-up-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}